import Internationalization from 'core/internationalization/Internationalization';
import I18nInternationalization from 'details/internationalization/i18n/I18nInternationalization';

const internationalizationService: Internationalization = new I18nInternationalization();

export default internationalizationService;